import React, { useState, useEffect } from 'react';
import { get } from '../../utils/network';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { Paper } from '@material-ui/core';

const LogsViewer = () => {
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [logText, setLogText] = useState('Cargando...');

    const formatDate = (date) => {
        const d = new Date(date);
        return d.toISOString().slice(0, 10); // YYYY-MM-DD
    };

    useEffect(() => {
        const fecha = formatDate(selectedDate);

        get(`logs/${fecha}`)
            .then(async (res) => {
                const text = await res.text();
                if (!res.ok) {
                    try {
                        const errObj = JSON.parse(text);

                        if (errObj.code === "ENOENT") {
                            setLogText("No hay logs para esa fecha.");
                        } else {
                            setLogText("Ocurrió un error al cargar los logs.");
                        }

                    } catch {
                        setLogText("Ocurrió un error inesperado.");
                    }
                    return;
                }

                setLogText(text);
            })
            .catch((err) => {
                console.error(err);
                setLogText("No se pudo conectar con el servidor.");
            });
    }, [selectedDate]);

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Paper style={{ padding: '1rem', marginTop: '1rem' }}>
                <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="yyyy-MM-dd"
                    margin="normal"
                    label="Seleccionar fecha"
                    value={selectedDate}
                    onChange={(date) => setSelectedDate(date)}
                />

                <pre style={{ whiteSpace: 'pre-wrap', marginTop: '1rem' }}>
                    {logText}
                </pre>
            </Paper>
        </MuiPickersUtilsProvider>
    );
};

export default LogsViewer;
